import { type DataForParent, microFrontListener } from '@b2ag/micro-front-tools'
import { useRouter } from 'vue-router'
import { PAGE_ANALYTICS_INFO } from '../page-types'
import { callbacksFromShoppingListMicroFrontIframe } from '../../contexts/shopping-list'

/* ------- MICROFRONT - SHOPPING LIST ------- */

export const listsRoutes = [
  {
    path: '/salesrep-shopping-list',
    name: 'technician-shopping-lists',
    component: () => import('@b2ag/micro-front-shopping-list/app'),
    props: () => {
      return {
        microFrontName: 'shopping-list',
        viewName: `all-tech-lists`,
      }
    },
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        router: useRouter() as any,
        callbackForMessages: (data: DataForParent) => callbacksFromShoppingListMicroFrontIframe(data),
      })
    },
    meta: {
      private: true,
      showSelectedCustomer: false,
      changeSelectedCustomer: false,
      analyticsPageInfo: PAGE_ANALYTICS_INFO.TECHNICIAN_SHOPPING_LISTS,
    },
  },
  {
    path: '/customer-shopping-list/:id',
    name: 'customer-shopping-list-details',
    component: () => import('@b2ag/micro-front-shopping-list/app'),
    props: (route) => ({
      microFrontName: 'shopping-list',
      viewName: 'shopping-list-details',
      id: route.params.id,
    }),
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        router: useRouter() as any,
        callbackForMessages: (data: DataForParent) => callbacksFromShoppingListMicroFrontIframe(data),
      })
    },
    meta: {
      private: true,
      showSelectedCustomer: false,
      changeSelectedCustomer: false,
      analyticsPageInfo: PAGE_ANALYTICS_INFO.LIST_DETAILS,
    },
  },
  {
    path: '/sending-shopping-list/:shoppingListId',
    name: 'send-shopping-list',
    component: () => import('@b2ag/micro-front-shopping-list/app'),
    props: (route) => {
      return {
        microFrontName: 'shopping-list',
        viewName: 'sent',
        shoppingListId: route.params.shoppingListId,
      }
    },
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        router: useRouter() as any,
      })
    },
    meta: {
      private: true,
      showSelectedCustomer: false,
      changeSelectedCustomer: false,
      analyticsPageInfo: PAGE_ANALYTICS_INFO.SEND_SHOPPING_LIST,
    },
  },
]
